<template>
    <div>
        <div class="form">
            <form id="payment-form" @submit.prevent="submitHandler">
                <NameOnCard @name="updateName" :error="nameError" @disable-error="disableError"/>
                <div id="card-element" class="card-only"></div>
                <button class="button expand primary" type="submit">
                    <span>Pay {{amountFormatted}}</span>
                </button>
                <PaymentError :error="displayError"/>
            </form>
        </div>
    </div>
</template>

<script>
import {
  instantiateStripe,
  pay,
  confirmSecret,
  confirmPayment,
  createPaymentMethod,
} from '../stripe-elements';
import PaymentError from '../PaymentError.vue';
import PaymentsMixin from '../PaymentsMixin.vue';
import NameOnCard from '../NameOnCard.vue';
import { formatMoney } from '../../../utilities/helpers';

export default {
  name: 'SCAOneOffPaymentForm',
  mixins: [PaymentsMixin],
  data() {
    return {
      displayError: '',
      disabled: true,
      nameOnCard: '',
      nameError: false,
    };
  },
  props: {
    stripePublicKey: {
      type: String,
      required: true,
    },
    stripeAccountId: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: false,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    amountFormatted() {
      return formatMoney(this.amount);
    },
  },
  methods: {
    submitHandler() {
      this.nameError = false;
      this.displayError = '';
      if (this.nameOnCard.length === 0) {
        this.displayError = 'Please fill in the Name on card';
        this.nameError = true;
        return;
      }
      this.submitPayment();
    },
    async redirectAfterSuccessfulPayment(paymentIntent) {
      const result = await confirmPayment(paymentIntent.id, this.orderId);
      if (result.order !== undefined) {
        const {uuid} = result.order;
        const url = `/order/${uuid}`;

        this.$emit('payment-successful', uuid);

        window.location.href = url;
      } else {
        this.handleErrorMessages(result.data);
      }
    },
    async submitPayment() {
      if (this.disabled === false) {
        this.$emit('emit-global-loading', true);
      }
      const { paymentMethod } = await createPaymentMethod(this.nameOnCard);
      if (paymentMethod) {
        const { data, status } = await pay(this.orderId);
        const paymentIntent = data;
        if (status === false) {
          this.handleErrorMessages(paymentIntent);
        } else if (this.confirmPaymentHasSucceeded(paymentIntent)) {
          await this.redirectAfterSuccessfulPayment(paymentIntent);
        } else {
          const clientSecret = paymentIntent.client_secret;
          const result = await confirmSecret(clientSecret);
          const paymentIntentResult = result.paymentIntent;
          if (result.error) {
            this.handleErrorMessages(result);
          } else if (this.confirmPaymentHasSucceeded(paymentIntentResult)) {
            await this.redirectAfterSuccessfulPayment(paymentIntentResult);
          }
        }
      }
    },
  },
  components: {
    PaymentError,
    NameOnCard,
  },

  beforeMount() {

  },
  mounted() {
    const { stripeAccountId, stripePublicKey } = this;
    instantiateStripe(Stripe, {
      stripeAccountId,
      stripePublicKey,
    });
    this.mountCardAndAddSubmitListener();
  },
};
</script>

<style scoped>

    form > * + * {
        margin-top: 20px;
    }

    input {
        border: 0px solid;
    }

</style>
